import * as React from "react";
import { type FC } from "react";

import { Caption, Row, Value } from "../../FiasFnsManualEditor.styles";
import { IndexField } from "../../../../FiasInput/IndexField/IndexField";

interface IndexProps {
    path: string;
    value: string | undefined;
    skipDefaultValidation?: boolean;
    onValueChange: (next: string) => void;
}

export const Index: FC<IndexProps> = ({ path, value, skipDefaultValidation, onValueChange }) => (
    <Row>
        <Caption>Индекс</Caption>
        <Value>
            <IndexField
                optional
                path={path}
                data-tid={"FiasPostalCode"}
                width={350}
                value={value ?? ""}
                skipDefaultValidation={skipDefaultValidation}
                onChange={onValueChange}
            />
        </Value>
    </Row>
);
